import { render } from "./PackageContractTerms.vue?vue&type=template&id=4c3e75ed&scoped=true"
import script from "./PackageContractTerms.vue?vue&type=script&lang=js"
export * from "./PackageContractTerms.vue?vue&type=script&lang=js"

import "./PackageContractTerms.vue?vue&type=style&index=0&id=4c3e75ed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3e75ed"]])

export default __exports__